import type { ComponentProps } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import AISparkleIcon from 'components/Search/SearchForm/AISparkleIcon'

const Button = styled(TextButton)`
  min-width: 0;
  height: ${rem(32)};
  padding-inline: ${rem(10)} ${rem(14)};
  border: 1px solid transparent;
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: transparent;
  background-image:
    linear-gradient(
      ${props => props.theme.palette.neutral.surface.normalBackground},
      ${props => props.theme.palette.neutral.surface.normalBackground}
    ),
    ${props => props.theme.palette.product.ai.gradient};
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0 0 ${rem(4)} ${props => props.theme.palette.product.ai.light35};
  font-weight: 400;
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  text-decoration: none;
  white-space: nowrap;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }

  &:hover:not(:disabled) {
    background-image:
      linear-gradient(
        ${props => props.theme.palette.neutral.surface.lightBackground},
        ${props => props.theme.palette.neutral.surface.lightBackground}
      ),
      ${props => props.theme.palette.product.ai.gradient};
  }

  &:disabled {
    box-shadow: none;
    opacity: 0.6;
  }
`

type Props = Omit<ComponentProps<typeof TextButton>, 'kind' | 'startIcon'>

export default function AIActionButton({ size = 'medium', ...props }: Props) {
  return <Button {...props} kind="tertiary" size={size} startIcon={<AISparkleIcon size="S" />} />
}
